// ##### Komarov 2025-07-18
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 23-11-03 Komarov
import { Media } from '../../../../../helpers/MediaConfig.js';
// ##### Komarov 2025-07-18
import {
  getPax,
  setCounterAdults,
  setCounterChild,
  setCounterRooms
} from '../../../../../Redux/actions/index.js';
// ##### 25-05-21 Komarov
import HotelsPaxChoiceDiv from './HotelsPaxChoiceDiv.jsx';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery.js';

// ##### Komarov 2025-07-18
const HotelsPaxChoice = () => {
  // ##### 25-05-10 Komarov
  const searchProps = useValidateQuery();
  // ##### 24-09-10 Komarov
  // const totalPaxRedux = useSelector((state) => state.paxchoice.pax);
  const totalPaxReduxAdults = useSelector(state => state.paxchoice.pax.adults);
  const totalPaxReduxChildren = useSelector(
    state => state.paxchoice.pax.children
  );
  const totalPaxReduxRooms = useSelector(state => state.paxchoice.pax.rooms);

  const { adults: counterAdults, children: counterChild, rooms: counterRooms } = useSelector(state => state.paxchoice.pax);

  const dispatch = useDispatch();

  // ##### Komarov 2025-07-21
  useEffect(() => {
    dispatch(setCounterAdults(searchProps?.adults
      ? parseInt(searchProps?.adults)
      : totalPaxReduxAdults || 1));
  }, []);

  useEffect(() => {
    dispatch(setCounterChild(searchProps?.children
      ? parseInt(searchProps?.children)
      : totalPaxReduxChildren || 0));
  }, []);

  useEffect(() => {
    dispatch(setCounterRooms(searchProps?.rooms
      ? parseInt(searchProps?.rooms)
      : totalPaxReduxRooms || 1));
  }, []);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(getPax(counterAdults, counterChild, counterRooms));
    // ##### 23-04-12 Komarov
  }, [counterAdults, counterChild, counterRooms, dispatch]);

  return (
    // ##### 22-10-26 Komarov - start
    <>
      {/* ##### 23-11-03 Komarov */}
      <Media lessThan="Mobile-L-425-768">
        <HotelsPaxChoiceDiv
          className="FrontHotelPaxChoiceWrapper"
          style={{ marginTop: '-30px' }}
        />
      </Media>
      {/* ##### 23-11-13 Komarov */}
      <Media at="Mobile-L-425-768">
        <HotelsPaxChoiceDiv
          className="FrontHotelPaxChoiceWrapper_SmallLandscape"
          style={{ transform: 'translate3d(-5vw, 50vw, 0vw)' }}
        />
      </Media>
      <Media at="Tablet-768-1024">
        <HotelsPaxChoiceDiv
          className="FrontHotelPaxChoiceWrapper_SmallLandscape"
          // ##### 24-02-08 Komarov
          // style={{transform: 'translate3d(-18vw, 28vw, 0vw)'}}
          style={{ transform: 'translate3d(-3vw, 28vw, 0vw)' }}
        />
      </Media>
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <HotelsPaxChoiceDiv className="FrontHotelPaxChoiceWrapper" />
      </Media>
    </>
    // ##### 22-10-26 Komarov - end
  );
};

export default HotelsPaxChoice;
